import api from '@/api/axios';
import { TherapistTag } from '@/stores/store.types';

export const fetchTherapistTags = async (): Promise<TherapistTag[]> => {
  const res = await api.get('/api/therapist/tags');
  return res.data;
};

export const createTherapistTags = async (
  tags: string[],
): Promise<TherapistTag[]> => {
  const res = await api.post('/api/therapist/tags', { tags });
  return res.data;
};

export const updateTherapistTag = async (
  tagId: string,
  name: string,
): Promise<TherapistTag> => {
  const res = await api.put(`/api/therapist/tags/${tagId}`, { name });
  return res.data;
};

export const deleteTherapistTags = async (tagIds: string[]): Promise<void> => {
  await api.delete('/api/therapist/tags', { data: { tagIds } });
};
